/**
 * Slider Component
 *
 * @file slider.js
 */

import $ from "jquery";
import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination, Autoplay, EffectFade, Controller, Thumbs, Keyboard, Mousewheel } from 'swiper/core';
SwiperCore.use([Navigation, Pagination, Autoplay, EffectFade, Controller, Thumbs, Keyboard, Mousewheel]);

import 'swiper/swiper-bundle.css';

const slider = (() => {
  /**
   * fullSlider
   * Full width slider settings
   */
  const fullSlider = () => {
    const homeSlide = new Swiper('.main-slide', {
      effect: 'fade', 
      fadeEffect: {
        crossFade: true
      },
      speed: 1500,
      loop: false,
      navigation: {
        nextEl: ".main-slide-next",
        prevEl: ".main-slide-prev",
      },
      on: {
        init: function(){
          // Video ended event
          var videos = document.querySelectorAll('.nm-slide-box video');
          videos.forEach(function (video, index) {
            video.addEventListener('ended', function () {
              video.currentTime = 0;
              // Go to the next slide
              // homeSlide.slideNext();
            });
          });

          // Auto-play image slide after 5 seconds
          setTimeout(function () {
            // Check if the current slide is an image slide
            var activeSlide = homeSlide.slides[homeSlide.activeIndex];
            var isImageSlide = activeSlide.querySelector('img');
            // If it's an image slide, go to the next slide
            // if(homeSlide.activeIndex == 0){
            //   if (isImageSlide) {
            //     homeSlide.slideNext();
            //   }
            // }
          }, 5000);


          // if($(".main-slide .swiper-slide.swiper-slide-active").find("video")[0]){
          //   homeSlide.autoplay.stop();
          // } else{
          //   homeSlide.autoplay.start();
          // }
        },
        transitionStart: function(){
          var videos = document.querySelectorAll('.homeSlideVideo');
          Array.prototype.forEach.call(videos, function(video){
            video.addEventListener('ended', function () {
              video.currentTime = 0;
            });
            video.pause();
          });
        },
        transitionEnd: function(){
          var activeIndex = this.activeIndex;
          var activeSlide = document.getElementsByClassName('nm-slide-box')[activeIndex];
          var activeSlideVideo = activeSlide.getElementsByTagName('video')[0];
          if(activeSlideVideo){
            activeSlideVideo.play();
          }
        },
      }
    });
    homeSlide.on('slideChange', function (e) {
      $(".main-slide-thumb .main-thumb-item").removeClass("active");
      $(".main-slide-thumb .main-thumb-item").eq(homeSlide.activeIndex).addClass("active");
      $(".main-slide-thumb .main-thumb-item").on("click", function(el){
        // if (el.type != "click"){
        //   setTimeout(function () {
        //     // Check if the current slide is an image slide
        //     var isImageSlide = $(".main-slide .swiper-slide").eq(homeSlide.activeIndex).find('img');
        //     if(isImageSlide){
        //       homeSlide.slideNext();
        //     }
        //     // If it's an image slide, go to the next slide
        //     // if (isImageSlide) {
        //     //   homeSlide.slideNext();
        //     // }
        //   }, 6500);
        // }
      });
    });
    $(".main-slide-thumb .main-thumb-item").on("click", function(){
      homeSlide.slideTo($(this).index());	
    });
  };

  const changeBgSlide = () => {
    const backgroundDiv = $('#changeBg');
    const imagesData = backgroundDiv.attr('data-images');

    if (imagesData) {
      const images = imagesData.split(',');
      let currentIndex = 0;

      function changeBackground() {
        currentIndex = (currentIndex + 1) % images.length;
        backgroundDiv.fadeOut(1000, function() {
          backgroundDiv.css('background-image', `url(${images[currentIndex]})`);
          backgroundDiv.fadeIn(1000);
        });
      }

      backgroundDiv.css('background-image', `url(${images[currentIndex]})`);
      setInterval(changeBackground, 5000); // 10 saniyede bir değişim
    } else {
      console.error('data-images attribute is missing or empty.');
    }
  }

  const numberOfValueSlider = () => {
    $(".number-value-tab-swipe .item").on("click", function(){
      $(".number-value-tab-swipe .item").removeClass("active");
      $(this).addClass("active");
      $(".number-value-tab-swipe").removeClass("swiper-1 swiper-2 swiper-3 swiper-4 swiper-5")
      $(".number-value-tab-swipe").addClass("swiper-"+ parseInt($(this).index() + 1));
      $(".number-value-tab-item").removeClass("tab-active");
      $(".number-value-tab-item").eq($(this).index()).addClass("tab-active");
      var firstSwSlide = document.querySelector('.tab-active .first-number-carousel');
      var secondSwSlide = document.querySelector('.tab-active .second-number-carousel');
      if(firstSwSlide){
        var firstSwSlideTb = firstSwSlide.swiper;
        $(".number-prev-arrow").on("click", function(){
          firstSwSlideTb.slidePrev();
        });
        $(".number-next-arrow").on("click", function(){
          firstSwSlideTb.slideNext();
        });
      }
      if(secondSwSlide){
        var secondSwSlideTb = secondSwSlide.swiper;
        $(".number-prev-arrow").on("click", function(){
          secondSwSlideTb.slidePrev();
        });
        $(".number-next-arrow").on("click", function(){
          secondSwSlideTb.slideNext();
        });
      }
    });
    const numberValueTab = new Swiper('.number-value-tab', {
      slidesPerView: 1.5,
      spaceBetween: 0,
      loop:false,
      breakpoints: {
        0: {
          slidesPerView: 1.1,
          spaceBetween: 0,
        },
        680: {
          slidesPerView: 1.5,
          spaceBetween: 0,
        },
        992: {
          slidesPerView: 1.5,
          spaceBetween: 0,
        },
      },
      on: {
        click(event) {
            numberValueTab.slideTo(this.clickedIndex);	
        },
      },
    });


    var firstNubmerCarouselSl = new Swiper('.first-number-carousel', {
      slidesPerView: 4,
      spaceBetween: 15,
      loop:false,
      breakpoints: {
        0: {
          slidesPerView: 1.3,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 15,
        },
        1380: {
          slidesPerView: 4,
          spaceBetween: 15,
        },
        1480: {
          slidesPerView: 4,
          spaceBetween: 15,
        },
      },
      on: {
        init: function () {
        },
      },
    });
    var secondNubmerCarouselSl = new Swiper('.second-number-carousel', {
      slidesPerView: 2,
      spaceBetween: 30,
      loop:false,
      navigation: {
        nextEl: ".second-arrow-next-arrow",
        prevEl: ".second-arrow-prev-arrow",
      },
      breakpoints: {
        0: {
          slidesPerView: 1, 
          spaceBetween: 0,
        },
        768: {
          slidesPerView: 1, 
          spaceBetween: 0,
        },
        1024: {
          slidesPerView: 1.2, 
          spaceBetween: 15,
        },
        1300: {
          slidesPerView: 2, 
          spaceBetween: 30,
        },
      },
    });
    var firstSwSlide = document.querySelector('.tab-active .first-number-carousel');
    if(firstSwSlide){
      var firstSwSlideTb = firstSwSlide.swiper;
      $(".number-prev-arrow").on("click", function(){
        firstSwSlideTb.slidePrev();
      });
      $(".number-next-arrow").on("click", function(){
        firstSwSlideTb.slideNext();
      });
    }
    numberValueTab.on('slideChange', function (e) {
    });


    
    var firstNubmerCarouselSl = new Swiper('.first-number-carousel2', {
      slidesPerView: 4,
      spaceBetween: 15,
      loop:false,
      navigation: {
        nextEl: ".number-next-arrow2",
        prevEl: ".number-prev-arrow2",
      },
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          spaceBetween: 30,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 15,
        },
        1380: {
          slidesPerView: 4,
          spaceBetween: 15,
        },
        1480: {
          slidesPerView: 4,
          spaceBetween: 15,
        },
      },
    });
  }
  const homeNewsSlider = () => {
    // const homeNewsSliderTitle = new Swiper('.news-first-title', {
    //   slidesPerView: 1,
    //   spaceBetween: 0,
    //   watchSlidesProgress: true,
    //   loop:false,
    //   allowTouchMove: false,
    //   effect: 'fade', 
    //   fadeEffect: {
    //     crossFade: true
    //   },
    // });


    $(".home-arrow-prev").on("click", function(){
      
    });
    $(".home-arrow-prev").on("click", function(){
      // homeNewsSlider.updateSize();
      // homeNewsSlider.updateSlides();
      // homeNewsSlider.updateProgress();
      // homeNewsSlider.updateSlidesClasses();
    });
    $(window).resize(function(){
      if($(window).width() >= 992 ){
        location.reload();
      }
    });
    const homeNewsSlider = new Swiper('.hm-nw-car', {
      slidesPerView: 4,
      // slidesPerView: 4.1, 
      spaceBetween: 25,
      loop:false,
      navigation: {
        nextEl: ".home-arrow-next",
        prevEl: ".home-arrow-prev",
      },
      // thumbs: {
      //   swiper: homeNewsSliderTitle,
      // },
      breakpoints: {
        0: {
          slidesPerView: 1, 
          spaceBetween: 15,
        },
        320: {
          slidesPerView: 1.1, 
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 2.2, 
          spaceBetween: 15,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
        1100: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 25,
        },
      },
      on: {
        // click(event) {
        //   homeNewsSlider.slideTo(this.clickedIndex);	
        // },
      },
    });
    homeNewsSlider.on('reachEnd', function() {
      // setTimeout(function(){homeNewsSliderTitle.slideTo(0,0); homeNewsSlider.slideTo(0,0);}, 100);
    });
  }
  const homeStudySlider = () => {
    const homeStudySliderContent = new Swiper('.study-tab-content', {
      // direction: 'horizontal',
      // mousewheel: {
			// 	releaseOnEdges: true,
			// },
			// touchReleaseOnEdges: true,
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      watchSlidesProgress: true,
      speed:1200,
      // allowTouchMove: false,
    });
    const historySliderContent = new Swiper('.history-content-slide', {
      // direction: 'horizontal',
      // mousewheel: {
			// 	releaseOnEdges: true,
			// },
			// touchReleaseOnEdges: true,
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      watchSlidesProgress: true,
      speed:1200,
      // allowTouchMove: false,
    });
    const homeStudySliderTab = new Swiper('.number-value-tab-std', {
      slidesPerView: 1.5,
      spaceBetween: 0,
      speed:1200,
      loop:false,
      thumbs: {
        swiper: homeStudySliderContent,
      },
      breakpoints: {
        0: {
          slidesPerView: 1.1,
          spaceBetween: 0,
        },
        680: {
          slidesPerView: 1.5,
          spaceBetween: 0,
        },
        992: {
          slidesPerView: 1.5,
          spaceBetween: 0,
        },
      },
      on: {
        click(event) {
          homeStudySliderTab.slideTo(this.clickedIndex);	
        },
      },
    });
    const historyNumverVarouselTab = new Swiper('.history-number-carousel', {
      // direction: 'horizontal',
      // mousewheel: {
			// 	releaseOnEdges: true,
			// },
			// touchReleaseOnEdges: true,
      slidesPerView: "auto",
      spaceBetween: 140,
      speed:1200,
      loop:false,
      centeredSlides: true,
      slideToClickedSlide: true,
      grabCursor: true,
      thumbs: {
        swiper: historySliderContent,
      },
    });

    const historyNumverVarouselTab1 = new Swiper('.number-value-tab-swipe', {
      // direction: 'horizontal',
      // mousewheel: {
			// 	releaseOnEdges: true,
			// },
			// touchReleaseOnEdges: true,
      slidesPerView: "auto",
      spaceBetween: 60,
      speed:1200,
      loop:false,
      centeredSlides:true,
      slideToClickedSlide: true,
      slidesOffsetBefore: 0, 
      preventClicks :true,
      watchSlidesProgress: true,
      on: {
        init: function () {
          if($(".first-number-carousel .km-slide").length <= 4){
            $(".home-number-value-tab .number-value-arr-func").removeClass("km-arrow-show");
          } else {
            $(".home-number-value-tab .number-value-arr-func").addClass("km-arrow-show");
          }
        },
        slideChange: function () {
          $(".number-value-tab-swipe").addClass("no-transition");
          if($(".first-number-carousel .km-slide").length <= 4){
            $(".home-number-value-tab .number-value-arr-func").removeClass("km-arrow-show");
          } else if ($(".first-number-carousel .km-slide").length <= 4) {
            $(".home-number-value-tab .number-value-arr-func").addClass("km-arrow-show");
          } 
        },
      },
      breakpoints: {
        0: {
          spaceBetween: 15,
        },
        768: {
          spaceBetween: 20,
        },
        1024: {
          spaceBetween: 30,
        },
        1380: {
          spaceBetween: 40,
        },
      },
    });
    const historyNumverVarouselTab2 = new Swiper('.number-value-tab-swipe2', {
      // direction: 'horizontal',
      // mousewheel: {
			// 	releaseOnEdges: true,
			// },
			// touchReleaseOnEdges: true,
      slidesPerView: "auto",
      spaceBetween: 60,
      speed:1200,
      loop:false,
      centeredSlides:true,
      slideToClickedSlide: true,
      slidesOffsetBefore: 0, 
      preventClicks :true,
      watchSlidesProgress: true,
      allowTouchMove: false,
      navigation: {
        nextEl: ".number-val-tab-next",
        prevEl: ".number-val-tab-prev",
      },
      breakpoints: {
        0: {
          spaceBetween: 15,
        },
        768: {
          spaceBetween: 20,
        },
        1024: {
          spaceBetween: 30,
        },
        1380: {
          spaceBetween: 40,
        },
      },
      thumbs: {
        swiper: homeStudySliderContent,
      },
    });
    historyNumverVarouselTab1.on('slideChange', function (e) {
      $(".number-value-tab-item").removeClass("tab-active");
      $(".number-value-tab-item").eq(historyNumverVarouselTab1.activeIndex).addClass("tab-active");
    });
    historyNumverVarouselTab2.on('slideChange', function (e) {
      $(".number-value-tab-item").removeClass("tab-active");
      $(".number-value-tab-item").eq(historyNumverVarouselTab1.activeIndex).addClass("tab-active");
    });
    $(".number-value-tab-swipe2 .swiper-slide").on("click", function(){
      $(".number-value-tab-swipe2 .swiper-slide").removeClass("swiper-slide-active");
      $(this).addClass("swiper-slide-active");
    });

    homeStudySliderContent.on('slideChange', function (e) {
      // $(".home-study").css("background-color", $(".number-value-tab-std .swiper-slide").eq(homeStudySliderTab.activeIndex).data("color"));
      $(".number-value-tab-swipe2 .item").removeClass("active");
      $(".number-value-tab-swipe2 .item").eq(homeStudySliderContent.activeIndex).addClass("active");
      $(".number-value-tab-swipe2").removeClass("swiper-1 swiper-2 swiper-3 swiper-4 swiper-5")
      $(".number-value-tab-swipe2").addClass("swiper-"+ parseInt(homeStudySliderContent.activeIndex + 1));
    });
    homeStudySliderContent.on('slideChange', function (e) {
      if(!$(".history-number-carousel")){
        historyNumverVarouselTab.slideTo(e.activeIndex);	 
      }
    });
    historySliderContent.on('slideChange', function (e) {
      if($(".history-number-carousel")){
        historyNumverVarouselTab.slideTo(e.activeIndex);	 
      }
    });
    homeStudySliderContent.on('slideChange', function (e) {
        historyNumverVarouselTab2.slideTo(e.activeIndex);	
      $(".home-study").css("background-color", $(".number-value-tab-swipe2 .swiper-slide").eq(parseInt(historyNumverVarouselTab2.activeIndex)).data("color"));
    });
    homeStudySliderTab.on('slideChange', function (e) {
      // $(".home-study").css("background-color", $(".number-value-tab-std .swiper-slide").eq(homeStudySliderTab.activeIndex).data("color"));
    });

    $(".number-value-tab-swipe2 .item").on("click", function(){
      $(".number-value-tab-swipe2 .item").removeClass("active");
      $(this).addClass("active");
      homeStudySliderContent.slideTo($(this).index());	
      $(".home-study").css("background-color", $(this).data("color"));
      $(".number-value-tab-swipe2").removeClass("swiper-1 swiper-2 swiper-3 swiper-4 swiper-5")
      $(".number-value-tab-swipe2").addClass("swiper-"+ parseInt($(this).index() + 1));
    });
    $(".study-item a").hover(function() {
        $(this).find(".arr path").css("stroke",$(this).find(".arr").css("background-color"));
      }, function() {
        $(this).find(".arr path").css("stroke", "#FFF");
      }
    );
  }

  const detailGallery = () => {
    const homeSlide = new Swiper('.gallery-carousel', {
      slidesPerView: 3,
      spaceBetween: 30,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false, 
      },
      navigation: {
        nextEl: ".gallery-next",
        prevEl: ".gallery-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
        1380: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
    });
  };

  const rdCarousel = () => {
    const homeSlide = new Swiper('.r-d-carousel', {
      slidesPerView: 4,
      spaceBetween: 30,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false, 
      },
      navigation: {
        nextEl: ".r-d-next",
        prevEl: ".r-d-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1380: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
    });
  };

  const otherNewsCarousel = () => {
    const homeSlide = new Swiper('.other-news-carousel', {
      slidesPerView: 3,
      spaceBetween: 30,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false, 
      },
      navigation: {
        nextEl: ".other-news-next",
        prevEl: ".other-news-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
        992: {
          slidesPerView: 2.5,
          spaceBetween: 30,
        },
        1100: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
    });
  };

  const dtQualityCarousel = () => {
    const homeSlide = new Swiper('.dt-quality-carousel', {
      slidesPerView: 3,
      spaceBetween: 15,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false, 
      },
      navigation: {
        nextEl: ".quality-next",
        prevEl: ".quality-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 2.5,
          spaceBetween: 30,
        },
        1380: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
      },
    });
  };

  const dtSocialCarousel = () => {
    const homeSlide = new Swiper('.social-responsibility-carousel', {
      slidesPerView: 4,
      spaceBetween: 25,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false, 
      },
      navigation: {
        nextEl: ".r-d-next",
        prevEl: ".r-d-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1, 
          spaceBetween: 15,
        },
        320: {
          slidesPerView: 1.1, 
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 2.2, 
          spaceBetween: 15,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
        1100: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 25,
        },
      },
    });
  };

  const dtLogoPCarousel = () => {
    const homeSlide = new Swiper('.logo-package-carousel', {
      slidesPerView: 4,
      spaceBetween: 0,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false, 
      },
      navigation: {
        nextEl: ".logoP-next",
        prevEl: ".logoP-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1.2,
        },
        768: {
          slidesPerView: 2.5,
        },
        1024: {
          slidesPerView: 3,
        },
        1380: {
          slidesPerView: 4,
        },
      },
    });
  };

  const init = () => {
    fullSlider();
    changeBgSlide();
    numberOfValueSlider();
    homeNewsSlider();
    homeStudySlider();
    detailGallery();
    rdCarousel();
    otherNewsCarousel();
    dtQualityCarousel();
    dtSocialCarousel();
    dtLogoPCarousel();
  };

  return {
    init,
  };
})();

export default slider;
